import React from 'react';

/**
 * Unified diff (as produced by the backend DiffUtil) with added/removed lines tinted.
 * Very long lines wrap: marketing article bodies are single 10-16k character lines.
 */
const DiffView = ({ patch, maxHeight = 320 }) => {
  if (!patch) {
    return <div className="text-muted small">No text changes.</div>;
  }
  return (
    <pre className="diff-view" style={{ maxHeight }}>
      {patch.split('\n').map((line, i) => {
        let cls = 'diff-line';
        if (line.startsWith('+')) cls += ' diff-add';
        else if (line.startsWith('-')) cls += ' diff-del';
        else if (line.startsWith('@@')) cls += ' diff-hunk';
        return (
          <div key={i} className={cls}>
            {line || ' '}
          </div>
        );
      })}
    </pre>
  );
};

export default DiffView;
